/* eslint-disable max-lines-per-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { changeLanguage } from '../../../../actions/language';
import {
  numberWithCommas,
  flightBookingRoutes,
  Conditional,
  returnBookingTabList,
} from '../../../../utils/consts';
import {
  bookingApi,
  customerApi,
  gatewayApi,
  serviceTypeApi,
  ticketApi,
} from '../../../../services/apis';
import {
  Input,
  Dropdown,
  Button,
  CancelingProcessModal,
  MobileFlightInfoBooking,
  MobileFlightDetailsBooking,
  PassengerTable,
  Modal,
  Spinner,
  Toast,
  ProfileTab,
  SideBarPanel,
  NewsSlider,
  PNRComponent,
  BookingFlightDetails,
  BookingPriceDetails,
  Tooltip,
  MobileInfinityData,
} from '../../../../component';
import {
  HistoryIcon,
  TransactionIcon,
  ReserveIcon,
  EditIcon,
  InfoCircleIcon,
} from '~svg';
import {
  debouncing,
  generateFilterString,
  returnAirlineLogos,
} from '../../../../utils/utility';
import { fileHandlerUrl } from '../../../../utils/consts/server';
import TransactionFilter from './transactionFilter';
import ReserveFilter from './reserveFilter';
import HistoryFilter from './historyFilter';
import momentjs from 'moment-jalaali';
import CustomerModal from '../../customer/customerModal';
import ReactQuill from 'react-quill';
import '../../../../domain/profile/profile/bookingFlights/bookingFlights.scss';
import 'react-quill/dist/quill.snow.css';

let parsedQueryStr = {};
const TAB_LIST = returnBookingTabList(),
  SVG_COMPONENT = {
    issued: TransactionIcon,
    reserve: ReserveIcon,
    expired: HistoryIcon,
  };
class MobileBookingFlights extends Component {
  constructor(props) {
    super(props);
    let tabName = this.props.locationParam
      ? this.props.locationParam
      : 'issued';
    this.state = {
      selectUnpaidFlightList: [],
      serviceTypes: [],
      serviceName: [],
      originLst: [],
      destinationLst: [],
      destinations: [],
      selectedPassenger: [],
      passengerLst: [],
      flights: [],
      radioObj: [
        { name: 'personalproblem', selected: true },
        { name: 'airlineproblem', selected: false },
        { name: 'flightproblem', selected: false },
      ],
      onlineSupportData: '',
      perviousPassengersModalData: '',
      CustomerModalData: '',
      assignCustomerData: '',
      subjectKey: '',
      messageContent: '',
      departDate: '',
      orderDate: '',
      phrase: '',
      serviceType: '',
      selectedTab: tabName.selectedTab ? tabName.selectedTab : 'issued',
      transactionPhrase: '',
      transactionStartOrderDate: '',
      transactionEndOrderDate: '',
      transactionStartTravelDate: '',
      transactionEndTravelDate: '',
      reservePhrase: '',
      reserveStartOrderDate: '',
      reserveEndOrderDate: '',
      reserveStartTravelDate: '',
      reserveEndTravelDate: '',
      historyPhrase: '',
      historyStartOrderDate: '',
      historyEndOrderDate: '',
      historyStartTravelDate: '',
      historyEndTravelDate: '',
      transactionOrderResetDates: false,
      transactionTravelResetDates: false,
      reserveOrderResetDates: false,
      reserveTravelResetDates: false,
      historyOrderResetDates: false,
      historyTravelResetDates: false,
      cancelReasonData: null,
      cancelReason: false,
      showPnrModal: false,
      onlineSupport: false,
      perviousPassengersModal: false,
      CustomerModal: false,
      assignCustomer: false,
      showDetail: false,
      isShowTransactionOrderDropDown: false,
      isShowTransactionTravelDropDown: false,
      isShowReserveOrderDropDown: false,
      isShowReserveTravelDropDown: false,
      isShowHistoryOrderDropDown: false,
      isShowHistoryTravelDropDown: false,
      showPnrPanel: false,
      showCustomerModal: false,
      agree: false,
      showLoading: true,
      scrollLoading: false,
      cancelFlightIndex: 0,
      totalRecords: 0,
      selectedflightIndex: 0,
      showPassengerDetailId: 0,
      itemPerPage: 10,
      pageNumber: 1,
      message: 'booking.notfound',
      // amadeus
      gatewayName: 'tripsi',
      gatewayLst: [],
      pnr: '',
      leadLastName: '',
      pnrFlights: {},
      lastName: '',
    };
  }

  //#region  life cycle component

  componentDidMount() {
    let tabName = this.props.locationParam;
    this.setState(
      { selectedTab: tabName.selectedTab ? tabName.selectedTab : 'issued' },
      () => this.fetchFlightInfo(tabName.selectedTab || this.state.selectedTab),
    );
    this.fetchGateway();
  }

  assignCustomerId = (item) => {
    try {
      item.customerId = this.state.customerId;
      bookingApi.insert({ data: item }).then((result) => {
        this.setState({ customerId: 0, assignCustomer: false }, () =>
          this.fetchFlightInfo(),
        );
      });
    } catch (error) {
      console.error(error);
    }
  };

  fetchGateway = () => {
    try {
      gatewayApi.getGatewayList().then((result) => {
        this.setState({ gatewayLst: result });
      });
    } catch (error) {
      console.error(error);
    }
  };
  doSubmit = () => {
    this.setState({ pageNumber: 1 }, () => {
      this.fetchFlightInfo(this.state.selectedTab);
    });
  };
  // call insert markup when the user is counter and redirect to ticket page
  fetchAllCustomer = (item) => {
    try {
      customerApi
        .searchCustomer({
          profileId: item.onBehalfProfile.id,
          data: {
            phrase: '',
          },
        })
        .then((res) => {
          if (res.status === 200)
            this.setState(
              {
                customerLst: res.payload.data,
                showCustomerModal: this.state.customerClick,
                showCustomerModalData: item,
              },
              () => {
                this.setState({
                  assignCustomer: true,
                  assignCustomerData: item,
                });
              },
            );
        });
    } catch (error) {
      console.error(error);
    }
  };
  // send ticket for online support
  send = (bookingId) => {
    try {
      let { messageContent, subjectKey } = this.state;
      if (messageContent && subjectKey)
        ticketApi
          .createTicket({
            data: {
              _id: '0',
              bookingId,
              subject: subjectKey,
              message: messageContent.substring(3, messageContent.length - 4),
            },
          })

          .then((response) => {
            if (response.status === 200) {
              this.setState({ onlineSupport: false, onlineSupportData: null });
            }
          })
          .catch((reject) => {});
    } catch (error) {
      console.error(error);
    }
  };
  /* fetch User Flights info */
  fetchPnr = () => {
    try {
      let { gatewayName, pnr, gatewayLst } = this.state;
      if (gatewayLst.length) {
        let obj = {};

        gatewayLst[0].importPNRFields &&
          gatewayLst[0].importPNRFields.map(
            (item, index) => (obj[item] = this.state[item]),
          );
        this.setState({ showLoading: true });
        gatewayApi
          .importPNR({ gatewayName, pnr, data: { obj } })
          .then((response) => {
            if (response.status === 200) {
              this.setState({
                pnrFlights: response.payload.data,
                showPnrModal: true,
                showLoading: false,
              });
            } else {
              this.setState({
                message: 'booking.pnrnotfound',
                openToast: true,
                showPnrModal: false,
                showLoading: false,
              });
            }
          })
          .catch((reject) => {
            this.setState({
              message: 'booking.pnrnotfound',
              showPnrModal: false,
              openToast: true,
              showLoading: false,
            });
          });
      }
    } catch (error) {
      console.error(error);
    }
  };

  fetchFlightInfo = (selectTab) => {
    const {
      transactionStartOrderDate,
      transactionEndOrderDate,
      transactionEndTravelDate,
      transactionStartTravelDate,
      reserveStartTravelDate,
      reserveEndOrderDate,
      reserveStartOrderDate,
      reserveEndTravelDate,
      historyStartOrderDate,
      historyEndOrderDate,
      historyStartTravelDate,
      historyEndTravelDate,
      serviceType,
      transactionPhrase,
      reservePhrase,
      historyPhrase,
      selectedTab,
      pageNumber,
      itemPerPage,
      flights,
    } = this.state;
    let apiData = {};
    switch (selectedTab) {
      case 'issued':
        apiData = {
          phrase: transactionPhrase,
          startOrderDate: transactionStartOrderDate,
          endOrderDate: transactionEndOrderDate,
          startTravelDate: transactionStartTravelDate,
          endTravelDate: transactionEndTravelDate,
        };
        break;
      case 'unpaidreservation':
        apiData = {
          phrase: reservePhrase,
          startOrderDate: reserveStartOrderDate,
          endOrderDate: reserveEndOrderDate,
          startTravelDate: reserveStartTravelDate,
          endTravelDate: reserveEndTravelDate,
        };
        break;
      case 'expired':
        apiData = {
          phrase: historyPhrase,
          startOrderDate: historyStartOrderDate,
          endOrderDate: historyEndOrderDate,
          startTravelDate: historyStartTravelDate,
          endTravelDate: historyEndTravelDate,
        };
        break;
    }

    try {
      apiData.startOrderDate = apiData.startOrderDate
        ? momentjs(
            new Date(apiData.startOrderDate).toLocaleDateString(),
            'M/D/YYYY',
          ).format('YYYY-MM-DD')
        : '';
      apiData.endOrderDate = apiData.endOrderDate
        ? momentjs(
            new Date(apiData.endOrderDate).toLocaleDateString(),
            'M/D/YYYY',
          ).format('YYYY-MM-DD')
        : '';
      apiData.startTravelDate = apiData.startTravelDate
        ? momentjs(
            new Date(apiData.startTravelDate).toLocaleDateString(),
            'M/D/YYYY',
          ).format('YYYY-MM-DD')
        : '';
      apiData.endTravelDate = apiData.endTravelDate
        ? momentjs(
            new Date(apiData.endTravelDate).toLocaleDateString(),
            'M/D/YYYY',
          ).format('YYYY-MM-DD')
        : '';

      let payload = {
        data: {
          filter: generateFilterString([
            { key: 'startOrderDate', value: apiData.startOrderDate },
            { key: 'endOrderDate', value: apiData.endOrderDate },
            { key: 'startDate', value: apiData.startTravelDate },
            { key: 'endDate', value: apiData.endTravelDate },
            { key: 'firstName', value: apiData.phrase },
            { key: 'lastName', value: apiData.phrase },
            { key: 'invoiceNo', value: apiData.phrase },
            { key: 'ticketNumber', value: apiData.phrase },
            { key: 'serviceType', value: serviceType },
          ]),
        },
        pageNumber,
        itemPerPage,
      };
      let apiName = {
        issued: () => bookingApi.paidByUser(payload),
        reserve: () => bookingApi.reservedByUser(payload),
        history: () => bookingApi.historyByUser(payload),
        expired: () => bookingApi.expiredFlight(payload),
        unpaidreservation: () => bookingApi.reservedByUser(payload),
      };
      apiName[selectTab]()
        .then((res) => {
          if (res?.status === 200) {
            serviceTypeApi.fetchServiceTypeList().then((serviceTypes) => {
              this.setState({
                flights: [...flights, ...res?.payload?.data],
                serviceTypes: serviceTypes?.payload?.data,
                totalCount: res?.payload?.data?.[0]?.totalCount,
                showLoading: false,
                scrollLoading: false,
              });
            });
          } else {
            this.setState({
              flights: [],
              pageNumber: 1,
              totalCount: 0,
              scrollLoading: false,
              showLoading: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            flights: [],
            pageNumber: 1,
            totalCount: 0,
            showLoading: false,
            scrollLoading: false,
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

  returnShowDetailFlag = (selectedTab, index) => {
    this.setState({
      showDetail: selectedTab,
      selectedflightIndex: index,
    });
  };
  returnSelectedUnpaidFlightList = (selectedItem) => {
    let { selectUnpaidFlightList } = this.state;

    if (
      selectUnpaidFlightList.findIndex((flight) => flight === selectedItem) ===
      -1
    )
      selectUnpaidFlightList.push(selectedItem);
    else
      selectUnpaidFlightList = selectUnpaidFlightList.filter(
        (item) => item !== selectedItem,
      );
    this.setState({ selectUnpaidFlightList });
  };

  showFlightTicket = (id) => {
    window.open(`${flightBookingRoutes.printFlightTicket}?print=1&id=${id}`);
  };

  flightInvoice = (item) => {
    // create querry string and redirect to flight invoice
    parsedQueryStr['ad'] = item?.flights.adultCount;
    parsedQueryStr['ch'] = item?.flights.childCount;
    parsedQueryStr['in'] = item?.flights.infantCount;
    item?.flights.itineraries.map((fly, index) => {
      parsedQueryStr[`d${index + 1}`] =
        fly.flights[0].departureDateTime.split('T')[0];
      parsedQueryStr[`fr${index + 1}`] =
        fly.flights[index].departureAirport.code;
      parsedQueryStr[`to${index + 1}`] = fly.flights[index].arrivalAirport.code;
      parsedQueryStr['dl'] = true;
      parsedQueryStr['ft'] = item?.flights.flightType;
      parsedQueryStr['ol'] = false;
      parsedQueryStr['token'] = item._id;
    });
    sessionStorage.removeItem('selectFlight');
    sessionStorage.setItem('selectFlight', JSON.stringify(item?.flights));
    window.open(
      `#${flightBookingRoutes.flightInvoice}?${new URLSearchParams(
        parsedQueryStr,
      ).toString()}`,
    );
  };
  changeSubjectMessage = (event) => {
    this.setState({ subjectKey: event.target.value });
  };
  //message content for send ticket for online support
  changeMessageContent = (event) => {
    this.setState({ messageContent: event });
  };
  selectNewCustomer = (customerId, data) => {
    let customerLst = this.state.customerLst;
    let customer = { ...data };
    customer._id = customerId;
    customerLst.push(customer);
    this.setState({ customerId, customerLst }, () =>
      this.assignCustomerId(customer),
    );
  };
  selectCustomer = (event) => {
    let customerId = event.currentTarget.value;

    this.setState({ customerId });
  };

  debouncedFetchFlightInfo = debouncing(this.fetchFlightInfo, 700);

  handleSearch = (stateName, value) => {
    const { selectedTab } = this.state;
    this.setState(
      { [stateName]: value, pageNumber: 1, flights: [], showLoading: true },
      () => {
        this.debouncedFetchFlightInfo(selectedTab);
      },
    );
  };

  handleTransactionChangedropDown = (state) => {
    const { isShowTransactionOrderDropDown, isShowTransactionTravelDropDown } =
      this.state;
    switch (state) {
      case 'orderDropDown':
        this.setState({
          isShowTransactionOrderDropDown: !isShowTransactionOrderDropDown,
          isShowTransactionTravelDropDown: false,
        });
        break;
      case 'travelDropDown':
        this.setState({
          isShowTransactionOrderDropDown: false,
          isShowTransactionTravelDropDown: !isShowTransactionTravelDropDown,
        });
        break;
    }
  };

  handleTransactionOrderDateFilter = (event) => {
    const { selectedTab } = this.state;
    this.setState(
      {
        transactionStartOrderDate: event.startDate,
        transactionEndOrderDate: event.endDate,
        isShowTransactionOrderDropDown: false,
        pageNumber: 1,
        flights: [],
      },
      () => this.fetchFlightInfo(selectedTab),
    );
  };

  handleTransactionTravelDateFilter = (event) => {
    const { selectedTab } = this.state;
    this.setState(
      {
        transactionStartTravelDate: event?.startDate,
        transactionEndTravelDate: event.endDate,
        isShowTransactionTravelDropDown: false,
        pageNumber: 1,
        flights: [],
      },
      () => this.fetchFlightInfo(selectedTab),
    );
  };

  handleTransactionResetFilter = () => {
    const {
      selectedTab,
      transactionOrderResetDates,
      transactionTravelResetDates,
    } = this.state;
    this.setState(
      {
        flights: [],
        transactionPhrase: '',
        transactionStartOrderDate: '',
        transactionEndOrderDate: '',
        transactionStartTravelDate: '',
        transactionEndTravelDate: '',
        isShowTransactionOrderDropDown: false,
        isShowTransactionTravelDropDown: false,
        transactionOrderResetDates: !transactionOrderResetDates,
        transactionTravelResetDates: !transactionTravelResetDates,
        pageNumber: 1,
      },
      () => {
        this.fetchFlightInfo(selectedTab);
      },
    );
  };

  handleReserveChangedropDown = (state) => {
    const { isShowReserveOrderDropDown, isShowReserveTravelDropDown } =
      this.state;
    switch (state) {
      case 'orderDropDown':
        this.setState({
          isShowReserveOrderDropDown: !isShowReserveOrderDropDown,
          isShowReserveTravelDropDown: false,
        });
        break;
      case 'travelDropDown':
        this.setState({
          isShowReserveOrderDropDown: false,
          isShowReserveTravelDropDown: !isShowReserveTravelDropDown,
        });
        break;
    }
  };

  handleReserveOrderDateFilter = (event) => {
    const { selectedTab } = this.state;
    this.setState(
      {
        reserveStartOrderDate: event.startDate,
        reserveEndOrderDate: event.endDate,
        isShowReserveOrderDropDown: false,
        pageNumber: 1,
        flights: [],
      },
      () => this.fetchFlightInfo(selectedTab),
    );
  };

  handleReserveTravelDateFilter = (event) => {
    const { selectedTab } = this.state;
    this.setState(
      {
        reserveStartTravelDate: event?.startDate,
        reserveEndTravelDate: event.endDate,
        isShowReserveTravelDropDown: false,
        pageNumber: 1,
        flights: [],
      },
      () => this.fetchFlightInfo(selectedTab),
    );
  };

  handleReserveResetFilter = () => {
    const { selectedTab, reserveOrderResetDates, reserveTravelResetDates } =
      this.state;
    this.setState(
      {
        flights: [],
        reservePhrase: '',
        reserveStartOrderDate: '',
        reserveEndOrderDate: '',
        reserveStartTravelDate: '',
        reserveEndTravelDate: '',
        isShowReserveTripDropDown: false,
        isShowReserveOrderDropDown: false,
        isShowReserveTravelDropDown: false,
        reserveOrderResetDates: !reserveOrderResetDates,
        reserveTravelResetDates: !reserveTravelResetDates,
        pageNumber: 1,
      },
      () => {
        this.fetchFlightInfo(selectedTab);
      },
    );
  };

  handleHistoryChangedropDown = (state) => {
    const { isShowHistoryOrderDropDown, isShowHistoryTravelDropDown } =
      this.state;
    switch (state) {
      case 'orderDropDown':
        this.setState({
          isShowHistoryOrderDropDown: !isShowHistoryOrderDropDown,
          isShowHistoryTravelDropDown: false,
        });
        break;
      case 'travelDropDown':
        this.setState({
          isShowHistoryOrderDropDown: false,
          isShowHistoryTravelDropDown: !isShowHistoryTravelDropDown,
        });
        break;
    }
  };

  handleHistoryOrderDateFilter = (event) => {
    const { selectedTab } = this.state;
    this.setState(
      {
        historyStartOrderDate: event.startDate,
        historyEndOrderDate: event.endDate,
        isShowHistoryOrderDropDown: false,
        pageNumber: 1,
        flights: [],
      },
      () => this.fetchFlightInfo(selectedTab),
    );
  };

  handleHistoryTravelDateFilter = (event) => {
    const { selectedTab } = this.state;
    this.setState(
      {
        historyStartTravelDate: event?.startDate,
        historyEndTravelDate: event.endDate,
        isShowHistoryTravelDropDown: false,
        pageNumber: 1,
        flights: [],
      },
      () => this.fetchFlightInfo(selectedTab),
    );
  };

  handleHistoryResetFilter = () => {
    const { selectedTab, historyOrderResetDates, historyTravelResetDates } =
      this.state;
    this.setState(
      {
        flights: [],
        historyPhrase: '',
        historyStartOrderDate: '',
        historyEndOrderDate: '',
        historyStartTravelDate: '',
        historyEndTravelDate: '',
        isShowHistoryTripDropDown: false,
        isShowHistoryOrderDropDown: false,
        isShowHistoryTravelDropDown: false,
        historyOrderResetDates: !historyOrderResetDates,
        historyTravelResetDates: !historyTravelResetDates,
        pageNumber: 1,
      },
      () => {
        this.fetchFlightInfo(selectedTab);
      },
    );
  };

  filterPanels = () => {
    const { intl, language } = this.props;
    const {
        selectedTab,
        transactionPhrase,
        transactionStartOrderDate,
        transactionEndOrderDate,
        transactionStartTravelDate,
        transactionEndTravelDate,
        transactionOrderResetDates,
        transactionTravelResetDates,
        isShowTransactionOrderDropDown,
        isShowTransactionTravelDropDown,
        reservePhrase,
        reserveStartOrderDate,
        reserveEndOrderDate,
        reserveStartTravelDate,
        reserveEndTravelDate,
        reserveOrderResetDates,
        reserveTravelResetDates,
        isShowReserveOrderDropDown,
        isShowReserveTravelDropDown,
        historyPhrase,
        historyStartOrderDate,
        historyEndOrderDate,
        historyStartTravelDate,
        historyEndTravelDate,
        historyOrderResetDates,
        historyTravelResetDates,
        isShowHistoryOrderDropDown,
        isShowHistoryTravelDropDown,
      } = this.state,
      transactionFilterData = {
        phrase: transactionPhrase,
        isShowOrderDropDown: isShowTransactionOrderDropDown,
        isShowTravelDropDown: isShowTransactionTravelDropDown,
        orderStartDateValue: transactionStartOrderDate,
        orderEndDateValue: transactionEndOrderDate,
        travelStartDateValue: transactionStartTravelDate,
        travelEndDateValue: transactionEndTravelDate,
        orderResetDates: transactionOrderResetDates,
        travelResetDates: transactionTravelResetDates,
      },
      reserveFilterData = {
        phrase: reservePhrase,
        isShowOrderDropDown: isShowReserveOrderDropDown,
        isShowTravelDropDown: isShowReserveTravelDropDown,
        orderStartDateValue: reserveStartOrderDate,
        orderEndDateValue: reserveEndOrderDate,
        travelStartDateValue: reserveStartTravelDate,
        travelEndDateValue: reserveEndTravelDate,
        orderResetDates: reserveOrderResetDates,
        travelResetDates: reserveTravelResetDates,
      },
      historyFilterData = {
        phrase: historyPhrase,
        isShowOrderDropDown: isShowHistoryOrderDropDown,
        isShowTravelDropDown: isShowHistoryTravelDropDown,
        orderStartDateValue: historyStartOrderDate,
        orderEndDateValue: historyEndOrderDate,
        travelStartDateValue: historyStartTravelDate,
        travelEndDateValue: historyEndTravelDate,
        orderResetDates: historyOrderResetDates,
        travelResetDates: historyTravelResetDates,
      };
    switch (selectedTab) {
      case 'issued':
        return (
          <TransactionFilter
            intl={intl}
            language={language}
            transactionFilterData={transactionFilterData}
            handleSearch={this.handleSearch}
            handleChangedropDown={this.handleTransactionChangedropDown}
            handleOrderDateFilter={this.handleTransactionOrderDateFilter}
            handleTravelDateFilter={this.handleTransactionTravelDateFilter}
            handleResetFilter={this.handleTransactionResetFilter}
          />
        );
      case 'reserve':
        return (
          <ReserveFilter
            intl={intl}
            language={language}
            reserveFilterData={reserveFilterData}
            handleSearch={this.handleSearch}
            handleChangedropDown={this.handleReserveChangedropDown}
            handleOrderDateFilter={this.handleReserveOrderDateFilter}
            handleTravelDateFilter={this.handleReserveTravelDateFilter}
            handleResetFilter={this.handleReserveResetFilter}
          />
        );
      case 'expired':
        return (
          <HistoryFilter
            intl={intl}
            language={language}
            historyFilterData={historyFilterData}
            handleSearch={this.handleSearch}
            handleChangedropDown={this.handleHistoryChangedropDown}
            handleOrderDateFilter={this.handleHistoryOrderDateFilter}
            handleTravelDateFilter={this.handleHistoryTravelDateFilter}
            handleResetFilter={this.handleHistoryResetFilter}
          />
        );
    }
  };

  pageChange = (pageNumber) => {
    const { selectedTab } = this.state;
    this.setState({ pageNumber: pageNumber }, () => {
      this.fetchFlightInfo(selectedTab);
    });
  };

  //create prioblems list for canceling ticket
  initialProblems() {
    let { radioObj } = this.state;
    radioObj[0].selected = true;
    radioObj[1].selected = false;
    radioObj[2].selected = false;
    this.setState({ radioObj, agree: false, selectedPassenger: [] });
    // set default value for radioButton
    document.getElementById('personalproblem').checked = true;
    document.getElementById('roundtrip').checked = true;
    document.getElementById('radio0').checked = true;
  }
  //reset data for pagenumber , total count
  changeTab = (type) => {
    this.setState(
      {
        pageNumber: 1,
        showDetail: false,
        flights: [],
        showPnrPanel: false,
        totalCount: 0,
        selectedTab: type,
      },
      () => this.fetchFlightInfo(type),
    );
  };
  handleTabClick = (type) => {
    this.setState(
      {
        pageNumber: 1,
        showDetail: false,
        flights: [],
        showPnrPanel: false,
        totalCount: 0,
        selectedTab: type,
      },
      () => this.fetchFlightInfo(type),
    );
  };
  showPnrTab = () => {
    this.setState({
      selectedTab: 'importPnr',
      showPnrPanel: true,
      showDetail: false,
    });
  };

  returnPNRData = (pnr, leadLastName) => {
    this.setState({ pnr, leadLastName, showLoading: true }, () =>
      this.fetchPnr(),
    );
  };

  //#endregion
  //#region  Render design

  passengerModal = (passenger) => {
    return (
      <PassengerTable
        passengerLst={passenger}
        direction={this.props.language.direction}
        className="text-white"
      />
    );
  };
  renderPerviousPassengerslink = () => {
    return (
      <Modal
        title={this.props.intl.formatMessage({
          id: 'booking.passengerinfo',
        })}
        isOpen={this.state.perviousPassengersModal}
        onClose={() =>
          this.setState({
            perviousPassengersModal: false,
            perviousPassengersModalData: null,
          })
        }
      >
        {this.passengerModal(
          this.state.perviousPassengersModalData?.passengers,
        )}
      </Modal>
    );
  };
  //Create tabs

  renderTabs = () => {
    const { selectedTab, paidCount, reserveCount, expiredCount } = this.state;

    TAB_LIST[0].message.title = (
      <div>
        <FormattedMessage id="profile.transactions" />
      </div>
    );
    TAB_LIST[0].message.comment = (
      <div>
        <span className="">{paidCount}</span>
      </div>
    );
    TAB_LIST[1].message.title = (
      <div>
        <FormattedMessage id="profile.reservations" />
      </div>
    );
    TAB_LIST[1].message.comment = (
      <div>
        <span>{reserveCount}</span>
      </div>
    );
    TAB_LIST[2].message.title = (
      <div>
        <FormattedMessage id="booking.history" />
      </div>
    );
    TAB_LIST[2].message.comment = (
      <div>
        <span>{expiredCount}</span>
      </div>
    );
    return (
      <div className="w-100 pb-4 d-flex justify-content-between">
        {TAB_LIST.map((tab, tabIndex) => (
          <ProfileTab
            key={`tab-profile-${tabIndex}`}
            {...tab}
            svgIcon={React.createElement(SVG_COMPONENT[tab.tabName], {
              color: 'white',
              variant: 'svg-md-normal svg-sm-large svg-msmall',
            })}
            handleTabClick={this.handleTabClick}
            selectedTab={selectedTab}
          />
        ))}
      </div>
    );
  };

  // renderTabs = () => {
  //   let { selectedTab, paidCount } = this.state;
  //   let { paidTotalSum, reserveCount, expiredCount } = this.props;
  //   let profileId = sessionStorage.getItem('profile');
  //   let isAgency =
  //     profileId !== 'individual' &&
  //     this.props.userInfo.profiles.filter(
  //       (item) => item.profileId === parseInt(profileId),
  //     ).length &&
  //     this.props.userInfo.profiles.filter(
  //       (item) => item.profileId === parseInt(profileId),
  //     )[0].profile.businessType.code === '03';

  //   return (
  //     <div className="d-flex w-100 pb-4 text-muted justify-content-between ">
  //       <div className=" col-4 p-0 d-flex flex-row justify-content-center w-100 h-100 d-flex justify-content-center align-items-center">
  //         <div
  //           className={` d-flex align-items-center justify-content-start p-sm-3 py-3 px-2 w-100 cursor-pointer h-100 col-11 default-border-top-radius-small default-border-bottom-radius-small profile-tab-container-click glass ${
  //             selectedTab === 'issued'
  //               ? 'text-white bg-secondary'
  //               : 'text-third bg-primary'
  //           }`}
  //           onClick={() => {
  //             this.changeTab('issued');
  //           }}
  //         >
  //           <div className="icon-container p-sm-0 p-0 d-xs-flex d-none">
  //             <TransactionIcon
  //               color="white"
  //               variant="svg-md-xlarge svg-sm-xlarge svg-xs-xlarge"
  //             />
  //           </div>
  //           <div className="text-start d-flex flex-column px-xl-2 px-lg-1 px-sm-2 px-xs-2 px-0 mx-sm-1 mx-0">
  //             <span className="font-xl-normal font-sm-msmall font-smaller">
  //               <FormattedMessage id="profile.transactions" />
  //             </span>

  //             <span className="font-xl-small font-md-smaller font-xsmall">
  //               {/* {paidTotalSum && paidTotalSum.length > 18 ? '...' : ''}
  // 				{paidTotalSum && paidTotalSum.slice(0, 18)} */}
  //               {numberWithCommas(
  //                 paidTotalSum && (paidTotalSum / 10).toFixed(0),
  //               )}
  //               {/* {paidTotalSum && x > 7 ? paidTotalSum.slice(0, 7) : paidTotalSum}
  // 							&nbsp; */}
  //               {/* {paidCount} */}
  //               {/* <span className='px-1 font-smaller'>
  // 								<FormattedMessage id='profile.row' />
  // 							</span> */}
  //             </span>
  //           </div>
  //         </div>
  //       </div>
  //       {/* <div
  //         className={`d-flex flex-column  align-items-center font-smaller py-1 bg-primary  ${
  //           selectedTab === "reserve" ? "text-white" : ""
  //         }`}
  //         onClick={() => {
  //           this.changeTab("reserve");
  //         }}
  //         style={{ width: "31%", borderRadius: "1rem" }}
  //       >
  //         <FormattedMessage id="booking.reserves" />
  //       </div> */}
  //       <div className=" col-4 p-0 d-flex flex-row justify-content-center w-100 h-100 d-flex justify-content-center align-items-center">
  //         <div
  //           className={` d-flex align-items-center justify-content-start p-sm-3 py-3 px-2 w-100 cursor-pointer h-100 col-11 default-border-top-radius-small default-border-bottom-radius-small profile-tab-container-click glass ${
  //             selectedTab === 'unpaidreservation'
  //               ? 'text-white bg-secondary'
  //               : 'text-third bg-primary'
  //           }`}
  //           onClick={() => {
  //             this.changeTab('unpaidreservation');
  //           }}
  //         >
  //           <div className="icon-container p-sm-0 p-0 d-xs-flex d-none">
  //             <ReserveIcon
  //               color="white"
  //               variant="svg-md-xlarge svg-sm-xlarge svg-xs-xlarge"
  //             />
  //           </div>
  //           <div className="text-start d-flex flex-column px-xl-2 px-lg-1 px-sm-2 px-xs-2 px-0 mx-sm-1 mx-0">
  //             <span className="font-xl-normal font-sm-msmall font-smaller">
  //               <FormattedMessage id="profile.reservations" />
  //             </span>

  //             <span className="font-xl-small font-md-smaller font-xsmall">
  //               {/*{numberWithCommas(
  // 					reserveTotalSum && (reserveTotalSum / 10).toFixed(2)
  // 				)}
  // 				&nbsp; */}
  //               {reserveCount}
  //               {/* <span className='px-1 font-smaller'>
  // 								<FormattedMessage id='profile.row' />
  // 							</span> */}
  //             </span>
  //           </div>
  //         </div>
  //       </div>
  //       <div className=" col-4 p-0 d-flex flex-row justify-content-center w-100 h-100 d-flex justify-content-center align-items-center">
  //         <div
  //           className={` d-flex align-items-center justify-content-start p-sm-3 py-3 px-2 w-100 cursor-pointer h-100 col-11 default-border-top-radius-small default-border-bottom-radius-small profile-tab-container-click text-white glass ${
  //             selectedTab === 'expired'
  //               ? 'text-white bg-secondary'
  //               : 'text-third bg-primary'
  //           }`}
  //           onClick={() => {
  //             this.changeTab('expired');
  //           }}
  //         >
  //           <div className="icon-container p-sm-0 p-0 d-xs-flex d-none">
  //             <HistoryIcon
  //               color="white"
  //               variant="svg-md-xlarge svg-sm-xlarge svg-xs-xlarge"
  //             />
  //           </div>
  //           <div className="text-start d-flex flex-column px-xl-2 px-lg-1 px-sm-2 px-xs-2 px-0 mx-sm-1 mx-0">
  //             <span className="font-xl-normal font-sm-msmall font-smaller">
  //               <FormattedMessage id="booking.history" />
  //             </span>

  //             <span className="font-xl-small font-md-smaller font-xsmall">
  //               {expiredCount}
  //               {/* <span className='px-1 font-smaller'>
  // 								<FormattedMessage id='profile.row' />
  // 							</span> */}
  //             </span>
  //           </div>
  //         </div>
  //       </div>
  //       {/* {isAgency ? (
  //         <div
  //           className={`d-flex flex-column align-items-center font-smaller  py-1  bg-primary  r ${
  //             selectedTab === "importPnr" ? "text-white" : ""
  //           }`}
  //           onClick={() => {
  //             this.showPnrTab();
  //           }}
  //           style={{ width: "31%", borderRadius: "1rem" }}
  //         >
  //           <FormattedMessage id="booking.referencenumber" />
  //         </div>
  //       ) : (
  //         <></>
  //       )} */}
  //     </div>
  //   );
  // };
  assignCustomerModal = (item) => {
    const { customerLst } = this.state;
    return (
      <div className="font-small text-primary px-3 py-5 d-flex justify-content-center w-100">
        <div className="d-flex flex-column w-100 p-0 justify-content-start pt-2 align-items-center">
          <Dropdown
            direction="rtl"
            name={`customerId-${item._id}`}
            id={`customerId-${item._id}`}
            label="booking.selectcustomer"
            value={item.customerId ? item.customerId : '_id'}
            customClassName="dire "
            options={{
              data: customerLst,
              label: `fullName`,
              value: '_id',
            }}
            customeStyle={{
              directtion: 'rtl',
            }}
            onChange={(event) => this.selectCustomer(event)}
            isDbsearch={true}
            theme="dark"
            returnSearchPhrase={(event) => this.returnSearchPhrase(event)}
          />

          <div
            className="pt-1 cursor-pointer font-smaller d-flex w-100 pt-2 justify-content-end text-decoration-underline w-25"
            style={{ color: '#6c757d' }}
          >
            <i
              onClick={() =>
                this.setState({
                  CustomerModal: true,
                  CustomerModalData: item,
                })
              }
              style={{ color: '#6c757d' }}
            >
              <FormattedMessage id="profile.addCustomer" />
            </i>
          </div>
          <div className="d-flex w-100 p-0 justify-content-center align-items-center pt-2">
            <div className="d-flex w-50 ">
              <Button
                name={`save-assign-customer`}
                id={`save-assign-customer`}
                className="btn btn-secondary py-3 col-8 rounded text-white "
                label={this.props.intl.formatMessage({
                  id: 'booking.save',
                })}
                themeMode="dark"
                onClick={() => this.assignCustomerId(item)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  //modal for assign Customer
  renderAssignCustomerModal = () => {
    const { showCustomerModal } = this.state;
    if (showCustomerModal)
      return (
        <Modal
          title={this.props.intl.formatMessage({
            id: 'booking.asacustomer',
          })}
          modalName={`assignCustomer`}
          isOpen={this.state.assignCustomer}
          onClose={() => {
            this.setState({ assignCustomer: false, assignCustomerData: null });
          }}
        >
          {this.assignCustomerModal(this.state.assignCustomerData)}
        </Modal>
      );
  };
  // show modal
  showCustomerModal = () => {
    return (
      <Modal
        isOpen={this.state.customerModal}
        onClose={() => this.setState({ customerModal: false })}
        modalName="CustomerModal"
        title={this.props.intl.formatMessage({
          id: 'profile.addCustomer',
        })}
      >
        {this.addCustomerModal(
          this.state.CustomerModalData?.onBehalfProfile?.id,
        )}
      </Modal>
    );
  };
  addCustomerModal = (profileId) => {
    return (
      <CustomerModal
        profileId={profileId}
        themeMode="dark"
        selectNewCustomer={(customerId, customer) =>
          this.selectNewCustomer(customerId, customer)
        }
      />
    );
  };
  // showModal = (profileId) => {
  //   return (
  //     <div
  //       className='fade modal w-100 customerModal '
  //       id='CustomerModal'
  //       data-backdrop='false'>
  //       <div className='modal-dialog modal-md '>
  //         <div className='modal-content'>
  //           <div className='modal-header bg-primary pt-3'>
  //             <h5 className='modal-title text-center w-100 font-weight-bold text-uppercase text-white'>
  //               <FormattedMessage
  //                 id='profile.customermanagement'
  //                 defaultMessage='profile.customermanagement'
  //               />
  //             </h5>
  //             <button
  //               type='button'
  //               className='close text-white'
  //               data-dismiss='modal'>
  //               &times;
  //             </button>
  //           </div>
  //           <div className='modal-body px-3'>
  //             <CustomerModal
  //               profileId={profileId}
  //               selectNewCustomer={(customerId, customer) =>
  //                 this.selectNewCustomer(customerId, customer)
  //               }
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };
  //modal for send online support ticket
  renderOnlineSupportModal = () => {
    return (
      <Modal
        isOpen={this.state.onlineSupport}
        onClose={() =>
          this.setState({ onlineSupport: false, onlineSupportData: null })
        }
        title={this.props.intl.formatMessage({
          id: 'booking.sendproblem',
        })}
        titleClass="font-large"
        id={`onlineSupport`}
        // closeModal={this.closeModal}
      >
        {this.onlineSupportModal(this.state?.onlineSupportData)}
      </Modal>
    );
  };
  onlineSupportModal = (id) => {
    return (
      <div>
        <div className=" py-0">
          <div className="d-flex flex-column  w-100 font-small">
            <Input
              type="text"
              name={`subjectKey-${id}`}
              value={this.state.subjectKey}
              label="ticket.subject"
              themeMode="dark"
              iconUrl={null}
              inputClassName={'text-start px-sm-3 px-3'}
              onChange={this.changeSubjectMessage}
              outSideLabel={true}
              outSideLabelPosition="top"
              outSideLabelClass={
                'font-small text-dark d-flex flex-row justify-content-start'
              }
              boxColor="bg-white"
            />
            {/* for custom text input */}
            <ReactQuill
              className="pt-2 text-dark booking"
              placeholder={this.props.intl.formatMessage({
                id: 'ticket.description',
              })}
              value={this.state.messageContent}
              theme="snow"
              onChange={this.changeMessageContent}
            />
          </div>
        </div>
        <div className="modal-footer border-0  d-flex justify-content-center pb-2 w-100">
          <Button
            name={`send-onlineSupport-book`}
            id={`send-onlineSupport-book`}
            className="btn btn-secondary default-border-radius-small text-white "
            width=" col-7"
            label={this.props.intl.formatMessage({
              id: 'ticket.send',
            })}
            themeMode="dark"
            onClick={() => this.send(id)}
          />
        </div>
      </div>
    );
  };

  renderOnlineSupport = (id, index) => {
    let { direction } = this.props.language;
    return (
      <button
        name={`send-problem-${index}`}
        id={`send-problem-${index}`}
        className={`d-flex text-underline border-0 text-uppercase bg-transparent text-dark  justify-content-center align-items-center cursor-pointer  ${
          direction === 'rtl' ? 'font-smaller' : 'font-tiny'
        } font-weight-bold  outline-none`}
        onClick={() =>
          this.setState({ onlineSupportData: id, onlineSupport: true })
        }
      >
        <FormattedMessage id="booking.sendproblem" />
      </button>
    );
  };

  // show modal
  // showModal = (profileId, bookingFlight) => {
  //   return (
  //     <div
  //       className='fade modal w-100 customerModal'
  //       data-backdrop='false'
  //       id='CustomerModal'>
  //       <div className='modal-dialog modal-md ' style={{ maxWidth: "45%" }}>
  //         <div className='modal-content'>
  //           <div className='modal-header bg-primary pt-3'>
  //             <h5 className='modal-title text-center w-100 font-weight-bold text-uppercase text-white'>
  //               <FormattedMessage
  //                 id='profile.customermanagement'
  //                 defaultMessage='profile.customermanagement'
  //               />
  //             </h5>
  //             <button
  //               type='button'
  //               className='close text-white'
  //               data-dismiss='modal'>
  //               &times;
  //             </button>
  //           </div>
  //           <div className='modal-body px-3'>
  //             <CustomerModal
  //               profileId={profileId}
  //               selectNewCustomer={(customerId, customer) =>
  //                 this.selectNewCustomer(customerId, customer, bookingFlight)
  //               }
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };
  //modal for send online support ticket
  // renderOnlineSupportModal = (id) => {
  //   return (
  //     <Modal
  //       isOpen={this.state.onlineSupport}
  //       onClose={() => this.setState({ onlineSupport: false })}
  //       title={this.props.intl.formatMessage({
  //         id: "booking.sendproblem",
  //       })}
  //       modalName={`onlineSupport${id}`}
  //       // closeModal={this.closeModal}
  //     >
  //       {this.onlineSupportModal(id)}
  //     </Modal>
  //   );
  // };

  renderCancelModal = () => {
    let {
      passengerLst,
      cancelFlightIndex,
      selectedPassenger,
      radioObj,
      flights,
      selectedTab,
    } = this.state;
    if (this.state?.cancelReasonData?.tickets?.length) {
      return (
        // <div
        //   data-backdrop="false"
        //   className="fade modal "
        //   id={`cancelReason${item._id}`}
        // >
        <CancelingProcessModal
          isOpen={this.state.cancelReason}
          onClose={() => this.setState({ cancelReason: false })}
          isMobile={true}
          item={this.state.cancelReasonData}
          flag={selectedTab}
          flights={flights}
          cancelFlightType={this.state.cancelReasonData?.flights.flightType}
          passengerLst={this.state.cancelReasonData?.passengers}
          cancelFlightIndex={cancelFlightIndex}
          radioObj={radioObj}
          selectedPassenger={selectedPassenger}
          currentFlightId={this.state.cancelReasonData?._id}
          fetchFlightInfo={() => this.fetchFlightInfo(selectedTab)}
        />
        // </div>
      );
    }
  };

  renderCancelButton = (id, isCanceled, item) => {
    let { direction } = this.props.language;
    if (this.state.selectedTab === 'issued') {
      return (
        <div
          onClick={() => {
            // this.setState({ cancelReason: true, cancelReasonData: item });
            this.setState({
              onlineSupport: true,
              onlineSupportData: id,
            });
            // this.initialProblems()/;
          }}
          className={`cursor-pointer  d-flex text-underline border-0 text-uppercase text-dark   font-smaller justify-content-center align-items-center font-weight-bold  outline-none ${
            direction === 'rtl' ? 'font-smaller' : 'font-tiny'
          } justify-content-center align-items-center font-weight-bold  outline-none`}
        >
          <FormattedMessage id="booking.cancel" />
        </div>
      );
    } else {
      return (
        <div
          onClick={() => {
            //! call Api For archive booking data
          }}
          className="cursor-pointer  d-flex text-underline border-0 text-uppercase text-dark   font-smaller justify-content-center align-items-center font-weight-bold  outline-none"
        >
          <span
            className={`${direction === 'rtl' ? 'font-smaller' : 'font-tiny'}`}
          ></span>
          <FormattedMessage id="booking.cancel" />
        </div>
      );
    }
  };
  renderPayButton = (item) => {
    let { direction } = this.props.language;
    if (this.state.selectedTab == 'reserve' || this.state.showPnrPanel)
      return (
        <div
          onClick={() => this.flightInvoice(item)}
          className={`d-flex text-underline border-0 text-uppercase bg-transparent text-dark cursor-pointer  ${
            direction === 'rtl' ? 'font-smaller' : 'font-tiny'
          } justify-content-center align-items-center font-weight-bold  outline-none`}
        >
          <FormattedMessage id="booking.paynow" />
        </div>
      );
  };
  renderButtons = (item, index) => {
    let { direction } = this.props.language;
    let param = this.props.locationParam;
    return (
      <div className="d-flex w-100 text-dark mx-0 mt-2 px-0 py-3 mt-4 card d-flex justify-content-start default-border-radius-small">
        <div className="d-flex w-100 justify-content-around px-0 ">
          {this.renderPayButton(item)}
          {item.tickets && item.tickets.length ? (
            this.renderCancelButton(
              item._id,
              item.passengers[0].isCanceled,
              item,
            )
          ) : (
            <></>
          )}

          {/* {item.tickets && item.tickets.length
            ? this.renderCancelModal(item)
            : null} */}
          <div
            className={`d-flex text-underline border-0 text-uppercase text-dark  cursor-pointer  ${
              direction === 'rtl' ? 'font-smaller' : 'font-tiny'
            } justify-content-center align-items-center font-weight-bold  outline-none`}
            onClick={() => {
              this.setState({
                perviousPassengersModal: true,
                perviousPassengersModalData: item,
              });
            }}
          >
            <FormattedMessage id="booking.passengers" />
          </div>
          {this.state.selectedTab === 'issued' &&
          item.tickets.length &&
          item.tickets[0].ticketNumber ? (
            <div
              onClick={() =>
                item.tickets && item.tickets[0].ticketNumber ? (
                  this.showFlightTicket(item._id)
                ) : (
                  <></>
                )
              }
              className={`d-flex text-underline border-0 text-uppercase bg-transparent text-dark  cursor-pointer   ${
                direction === 'rtl' ? 'font-smaller' : 'font-tiny'
              } justify-content-center align-items-center  font-weight-bold  outline-none`}
            >
              <FormattedMessage id="booking.showticket" />
            </div>
          ) : null}
          {item.onBehalfProfile && item.onBehalfProfile.id && param.id ? (
            <div
              onClick={() => {
                this.fetchAllCustomer(item);
                this.setState({
                  showAssignCustomerModal: true,
                  flight: item,
                  customerId: item.customerId,
                });
              }}
              className={`
              d-flex ${
                item.customerId ? '' : 'text-underline'
              }  border-0 text-uppercase bg-transparent text-white  cursor-pointer  ${
                direction === 'rtl' ? 'font-smaller' : 'font-tiny'
              } justify-content-center align-items-center font-weight-bold  outline-none`}
            >
              {item.customerId ? (
                <div className=" mobile-light-color  ">
                  {item.customer && item.customer[0].fullName}
                  <span className=" cursor-pointer px-1">
                    <EditIcon
                      size={14}
                      color="#6668a3"
                      variant="svg-tiny svg-sm-small"
                    />
                  </span>
                </div>
              ) : (
                <FormattedMessage id="booking.asacustomer" />
              )}
            </div>
          ) : (
            <></>
          )}
          {this.renderOnlineSupport(item._id, index)}
        </div>
      </div>
    );
  };
  renderDetails = (
    mainItem,
    item,
    type,
    showDetail,
    index,
    flight,
    customer = [],
  ) => {
    if (showDetail || this.state.showPnrPanel)
      return (
        <div
          key={`detail${index}`}
          className="d-flex flex-row w-100 py-1 px-0 card card-header justify-content-center"
        >
          {this.renderFlightType(type, index)}
          {this.renderAirLine(item?.flights[0].operatingAirline)}
          <div className="d-flex justify-content-around px-0 w-100">
            {this.renderColumn(
              'departuredate',
              this.props.language.direction === 'ltr'
                ? `${
                    item?.flights[0].departureDateTime.split('T')[0]
                  } ${item?.flights[0].departureDateTime
                    .split('T')[1]
                    .substring(0, 5)}`
                : momentjs(
                    item?.flights[0].departureDateTime.split('T')[0],
                    'YYYY-M-D',
                  ).format('jYYYY-jMM-jDD'),
              false,
              'py-3 px-0 p-xl-0',
            )}
            {this.renderColumn(
              'flightno',
              item?.flights[0].flightNumber,
              false,
              ' py-3 px-0 p-xl-0',
            )}
            {!this.state.showPnrPanel
              ? this.renderColumn(
                  'asacustomer',
                  customer && customer[0] ? customer[0].fullName : '--',
                  false,
                  ' py-3 px-0 p-xl-0',
                )
              : this.renderColumn(
                  'pnr',
                  item.pnr ? item.pnr : '--',
                  false,
                  ' py-3 px-0 p-xl-0  font-gotham text-uppercase',
                )}
          </div>
        </div>
      );
  };
  renderCancelIcon = (ticket, flight, passengers, index) => {
    if (ticket && ticket.length > 0)
      return (
        ticket.find((item) => item.flightIndex == index) &&
        ticket.filter((item) =>
          item.status.find(
            (st) => parseInt(st.code) >= 1 && parseInt(st.code) !== 5,
          ),
        ).length > 0 && (
          <div
            className={`font-weight-bold col-xl-1 col-2 col-sm-1 text-secondary text-uppercase font-smaller p-0 mx-xl-0 mx-md-3 ${
              this.props.language.name == 'fa'
                ? 'd-flex justify-content-start'
                : ''
            }`}
          >
            {
              ticket.filter(
                (item) =>
                  item.flightIndex === index &&
                  item.status.find(
                    (st) => parseInt(st.code) >= 1 && parseInt(st.code) !== 5,
                  ),
              ).length
            }
            &nbsp; <FormattedMessage id="booking.of" /> &nbsp;
            {passengers.length} <FormattedMessage id="booking.canceled" />
          </div>
        )
      );
  };

  renderFlightType = (type, index) => {
    let { name } = this.props.language;
    if (name === 'en')
      return (
        <div
          className="d-flex justify-content-center align-items-center px-1"
          style={{
            borderRightWidth: 1,
            borderRightStyle: 'dashed',
            borderRightColor: '#aaacaf ',
          }}
        >
          <img
            style={{ width: 23, height: 35 }}
            alt="flight-type"
            src={require(`../../../../content/images/icon/${
              type == 'roundtrip'
                ? index == 0
                  ? 'origin.png'
                  : 'destination.png'
                : 'origin.png'
            }`)}
          />
        </div>
      );
    if (name === 'fa')
      return (
        <div style={{ borderLeft: 'dashed 1px gray' }} className="px-1">
          <img
            style={{ width: 23, height: 35 }}
            alt="flight-type"
            src={require(`../../../../content/images/icon/${
              type == 'roundtrip'
                ? index == 0
                  ? 'destination.png'
                  : 'origin.png'
                : 'destination.png'
            }`)}
          />
        </div>
      );
  };
  // close
  backButtonClick = () => {
    // this.setState({
    //   selectedFlight: {},
    //   selectedIndex: -1,
    //   showMobileDetail: false,
    // });
    // let { showDetail, showFilter } = this.state;
    // if (!showDetail && !showFilter) {
    //   this.props.navigate(
    //     `${flightBookingRoutes.selectFlightDate}?${new URLSearchParams(
    //         parsedQueryStr
    //       ).toString()}`
    //   );
    // } else if (showDetail) {
    //   this.setState({ showDetail: false });
    // } else if (showFilter) {
    //   this.setState({ showFilter: false });
    // }
  };
  // render main flight information
  renderMainFlight(flightList, index) {
    let { showDetail, selectedflightIndex } = this.state;
    if (flightList && flightList.flights && flightList.flights.itineraries) {
      let { name, direction } = this.props.language.name,
        totalPassenger =
          parseInt(flightList.flights.adultCount) +
          parseInt(flightList.flights.childCount) +
          parseInt(flightList.flights.infantCount);
      let itineraries =
        flightList.flights &&
        flightList.flights.itineraries &&
        flightList.flights.itineraries;
      return itineraries && !showDetail ? (
        <div
          className="d-flex w-100 flex-column mt-2 border-radius "
          key={`mainFlight-${index}`}
        >
          <div
            key={`flighLst-${index}`}
            className={`border-0 w-100 p-0 font-weight-bold text-left bg-third-light cursor-pointer  ${
              index === flightList.length - 1 ? 'mb-1' : 'mb-3'
            }`}
            // onClick={() => {
            //   this.setState({
            //     showDetail: true,
            //     selectedflightIndex: index,
            //   });
            // }}
          >
            <MobileFlightInfoBooking
              index={index}
              flightLength={flightList.length}
              item={flightList}
              totalPassenger={totalPassenger}
              flag={this.state.selectedTab}
              returnSelectedUnpaidFlightList={
                this.returnSelectedUnpaidFlightList
              }
              returnShowDetailFlag={this.returnShowDetailFlag}
            />
          </div>
        </div>
      ) : selectedflightIndex === index ? (
        <div
          className="d-flex w-100 flex-column mt-2 border-0 booking"
          key={`detail-${index}`}
        >
          <div className="mb-1">
            <MobileFlightDetailsBooking
              list={flightList.itineraries}
              name={name}
              direction={direction}
              intl={this.props.intl}
              flight={flightList}
              isBooking={true}
              totalPassenger={totalPassenger}
              parsedQueryStr={parsedQueryStr}
              returnToBackTab={() => this.setState({ showDetail: !showDetail })}
            />
            {/* <MobileFlightDetails
              list={flightList.itineraries}
              name={name}
              direction={direction}
              intl={this.props.intl}
              flight={flightList}
              isBooking={true}
              totalPassenger={totalPassenger}
              parsedQueryStr={parsedQueryStr}
            /> */}
            {this.renderButtons(flightList, index)}
            {/* <div
              onClick={() => this.setState({ showDetail: false })}
              className="d-flex bg-primary font-weight-bold justify-content-center py-3 w-100 align-items-center sticky-button shadow-lg rounded mt-2"
            >
              <span className="text-white font-small text-uppercase ">
                <FormattedMessage id="booking.back" />
              </span>
            </div> */}
          </div>
        </div>
      ) : null;
    }
  }

  renderMainCancelIcon = (cancelCount) => {
    return (
      cancelCount &&
      cancelCount > 0 && (
        <div
          className={`font-weight-bold text-secondary text-uppercase font-smaller ${
            this.props.language.name == 'fa'
              ? 'd-flex justify-content-start'
              : ''
          }`}
        >
          <FormattedMessage id="booking.canceled" />
        </div>
      )
    );
  };

  renderAirLine = (airline) => {
    return (
      <div className="d-flex flex-column  col-2 justify-content-center align-items-center">
        <img
          className="d-flex justify-content-center align-items-center"
          style={{ width: 25, height: 25 }}
          src={this.renderAilLineLogo(airline.code)}
          alt="airline"
        />
        <span className="text-dark font-smaller font-weight-bold d-flex py-1 justify-content-center">
          {airline.code}
        </span>
      </div>
    );
  };

  renderColumn = (message, value, isNumber, className) => {
    return (
      <div
        className={`d-flex flex-column text-uppercase font-weight-bold text-third  p-0 ${className} `}
      >
        <div className="w-100 text-center font-tiny pt-xl-0 pt-2">
          <FormattedMessage id={`booking.${message}`} />
        </div>

        <div className="w-100 text-uppercase font-xsmall text-center font-weight-bold text-dark pt-xl-2 pt-0 justify-content-center d-flex">
          {isNumber ? numberWithCommas(value) : value}
        </div>
      </div>
    );
  };
  renderflightList = () => {
    let {
      flights,
      notExist,
      pageNumber,
      gatewayName,
      showLoading,
      showPnrModal,
      scrollLoading,
      itemPerPage,
      totalCount,
      selectedTab,
    } = this.state;
    const {
      intl,
      language: { direction },
      userInfo,
    } = this.props;
    const profileFlag = localStorage.getItem('profile');
    if (flights.length > 0) {
      return (
        <div className="scrollll px-1">
          <MobileInfinityData
            isShowLoadingBar={scrollLoading}
            totalRecords={totalCount}
            itemPerPage={itemPerPage}
            data={flights}
            handleCallData={() => {
              this.setState({ scrollLoading: true });
              setTimeout(() => {
                this.setState(
                  {
                    pageNumber: pageNumber + 1,
                  },
                  () => {
                    this.debouncedFetchFlightInfo(selectedTab);
                  },
                );
              }, 1000);
            }}
            customClassName="pb-4"
          >
            {flights.map((item, index) => this.renderMainFlight(item, index))}
          </MobileInfinityData>
          <SideBarPanel direction={direction}>
            <div className="d-flex flex-column">
              {profileFlag !== 'individual' &&
              userInfo?.profiles?.filter(
                (item) => item.profileId === parseInt(profileFlag),
              )?.[0]?.profile?.businessType?.code === '06' ? (
                <PNRComponent
                  className={`bookingFlightsNewsCard bg-white ${
                    direction === 'rtl' ? 'p-lg-4' : 'p-xl-4 p-md-2'
                  } p-3`}
                  imgSource="computer-to-computer.jpg"
                  title="booking.pnrdesc"
                  gatewayName={gatewayName}
                  direction={direction}
                  intl={intl}
                  loading={showLoading}
                  returnPNRData={this.returnPNRData}
                  showPnrModal={showPnrModal}
                />
              ) : (
                <NewsSlider
                  parentClassName="p-0"
                  className="bookingFlightsNewsCard bg-third-light"
                  imgSource="news-hotel.jpg"
                  newsTitle="booking.parishotel"
                  newsDescription="booking.hoteldescription"
                  reserve="booking.bookhotels"
                />
              )}
            </div>
          </SideBarPanel>
        </div>
      );
    } else if (notExist) {
      return (
        <div className="col d-flex p-0 flex-column my-5">
          <div className="col-12 d-flex  justify-content-center align-items-center text-primary font-weight-bold h2">
            <FormattedMessage id="booking.noavailableflight" />
          </div>

          <div className="justify-content-center col-12 d-flex">
            <img
              src={require('../../../../content/images/icon/not-found.png')}
              alt="not-found"
            />
          </div>
        </div>
      );
    }
  };

  renderProfilelogo = (profile) => {
    if (profile?.basicInfo?.logo)
      return (
        <img
          src={`${fileHandlerUrl}/file/download/${profile.basicInfo.logo}`}
          alt="profile-logo"
          className="rounded-circle"
          style={{ width: '80px', height: '65px' }}
        />
      );
    else if (!profile?.basicInfo || !profile?.basicInfo?.logo)
      return (
        <div
          className="rounded-circle border border-primary text-white d-flex align-items-center"
          style={{ width: '80px', height: '65px' }}
        >
          <span className="m-auto">
            <FormattedMessage id="profile.logo" />
          </span>
        </div>
      );
  };

  renderAirplaneIcon(operatingAirlines, index, className) {
    let { name, direction } = this.props.language,
      { pageNumber, itemPerPage } = this.state;

    if (operatingAirlines.length) {
      return (
        <div
          className={`d-flex p-0 align-items-center justify-content-center h-100 ${className}`}
        >
          <span className="d-flex px-2 font-weight-bold text-dark font-small">
            {(pageNumber - 1) * itemPerPage + (index + 1)}
          </span>

          {operatingAirlines.map((market, index) => {
            let position = 10 * index;
            return (
              <img
                key={`img-${index}`}
                style={{
                  width: '35px',
                  height: '35px',
                  // zIndex: operatingAirlines.length - index,
                  marginLeft:
                    direction === 'ltr'
                      ? operatingAirlines.length === 1 || index === 0
                        ? '15px'
                        : `${position}px`
                      : '0px',
                  marginRight:
                    direction === 'rtl'
                      ? operatingAirlines.length === 1 || index === 0
                        ? '10px'
                        : `${position}px`
                      : '0px',
                }}
                title={market?.name?.[name]}
                className={`d-flex justify-content-center rounded-circle bg-white border mx-2 ${
                  index === 0 ? '' : 'position-absolute'
                }
                   
                   `}
                src={returnAirlineLogos(market.code)}
                alt="airline-logo"
              />
            );
          })}
        </div>
      );
    }
  }

  changeIcon = (id, addClassName, removeClassName) => {
    if (document.getElementById(id)) {
      document.getElementById(id).classList.add(addClassName);
      document.getElementById(id).classList.remove(removeClassName);
    }
  };

  renderDetailModal = (_id, modalName, stateName) => {
    return (
      <div className="d-flex align-items-center col-2 p-0 justify-content-start pb-1">
        <div
          className="px-1"
          onMouseOver={() => {
            this.changeIcon(`${modalName}-${_id}`);
            this.setState({ [stateName]: _id });
          }}
          onMouseLeave={() => {
            this.setState({ [stateName]: 0 });
            this.changeIcon(`${modalName}-${_id}`);
          }}
        >
          <InfoCircleIcon size={12} />
        </div>
      </div>
    );
  };

  returnDirection = (itineraries, item, flightsLength, name) => {
    let direction = '',
      sameAirport = false;
    itineraries?.map((item, index) => {
      let directionArray = direction.split('-');

      directionArray.length > 0 &&
      directionArray[directionArray.length - 1].includes(
        itineraries[index].flights[0].departureAirport.cityName[name],
      )
        ? (sameAirport = true)
        : (sameAirport = false);

      direction += ` ${
        sameAirport
          ? ''
          : itineraries?.[index]?.flights?.[0]?.departureAirport?.cityName?.[
              name
            ]
      }
      - ${
        itineraries?.[index]?.flights?.[
          itineraries?.[index]?.flights?.length - 1
        ]?.arrivalAirport?.cityName?.[name]
      }`;
    });
    return direction;
  };

  renderMainColumn = (
    mainValue,
    value,
    isNumber,
    className,
    id,
    type,
    titleColor = 'text-third',
    isDate = false,
  ) => {
    const { direction } = this.props.language;
    return (
      <div
        className={`flex-column d-flex font-weight-bold p-0 justify-content-center align-items-center ${className} `}
      >
        <Tooltip
          position={'top'}
          content={mainValue || ''}
          direction={direction}
          backgroundColor="warning"
          textColor="dark"
          customClassName={'w-100'}
        >
          <div
            className={`w-100 d-flex font-smaller text-start pt-xl-0 pt-2 text-truncate text-nowrap ${titleColor}`}
          >
            <span className="w-100 text-truncate">{mainValue || '---'}</span>
          </div>
        </Tooltip>

        <Tooltip
          position={'top'}
          content={numberWithCommas(value) || ''}
          direction={direction}
          backgroundColor="warning"
          textColor="dark"
          customClassName={'w-100'}
        >
          <div
            // style={{ direction: "ltr" }}
            className={`w-100 flex-column text-start font-weight-bold text-dark font-smaller d-flex text-capitalize`}
          >
            <span className="d-flex justify-content-start font-smaller text-truncate text-nowrap">
              {isNumber ? (
                <>
                  <div className="w-100 d-flex">
                    {numberWithCommas(value)}
                    {type === 'totalprice' ? (
                      this.renderDetailModal(
                        id,
                        'showPriceDetails',
                        'showPriceDetailId',
                      )
                    ) : (
                      <React.Fragment></React.Fragment>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="w-100 d-flex">
                    <span className="text-truncate">
                      {value ? value : '---'}
                    </span>

                    {type === 'passengerDetail' ? (
                      this.renderDetailModal(
                        id,
                        'showPassengerDetails',
                        'showPassengerDetailId',
                      )
                    ) : (
                      <React.Fragment></React.Fragment>
                    )}
                  </div>
                </>
              )}
            </span>
          </div>
        </Tooltip>
      </div>
    );
  };

  renderPnrModal = () => {
    let profileId = localStorage.getItem('profile');
    let profile = this.props?.userInfo?.profiles?.filter(
      (item) => item.profileId === parseInt(profileId),
    )?.[0]?.profile;
    const { pnrFlights } = this.state,
      { name, direction } = this.props.language;
    let allAirlines = pnrFlights?.flights?.itineraries?.map((itinery) => {
        return itinery.flights.map((f) => {
          return [f.operatingAirline];
        });
      }),
      flightsLength = pnrFlights?.flights?.itineraries
        ? pnrFlights?.flights?.itineraries.length
        : 0,
      passengerCount =
        pnrFlights?.flights?.adultCount +
        pnrFlights?.flights?.childCount +
        pnrFlights?.flights?.infantCount,
      operatingAirlines = [
        ...new Map(
          allAirlines?.flat(2).map((item) => [item.code, item]),
        ).values(),
      ],
      priceList = [];
    pnrFlights?.passengers?.forEach((element) => {
      if (
        element.type === 'adult' &&
        priceList.filter((item) => item.key === 'Adult').length === 0
      ) {
        priceList.push({ key: 'Adult', ...element.price });
      }
      if (
        element.type === 'child' &&
        priceList.filter((item) => item.key === 'Child').length === 0
      ) {
        priceList.push({ key: 'Child', ...element.price });
      }

      if (
        element.type === 'infant' &&
        priceList.filter((item) => item.key === 'Infant').length === 0
      ) {
        priceList.push({
          key: 'Infant',
          ...element.price,
        });
      }
    });
    priceList.push({
      key: 'Total',
      TotalPrice: pnrFlights?.totalPrice,
      Commission: pnrFlights?.commission || 0,
    });

    return (
      <div>
        <div className="d-flex col-12 px-4 justify-content-center align-items-center flex-column">
          {this.renderProfilelogo(profile)}
          <span className="d-flex justify-content-center text-white pb-2 col-4">
            {profile?.displayName?.[name]}
          </span>
          {/* <span className="d-flex pt-2 text-white">
            <FormattedMessage id="booking.ticketinfo" />
          </span> */}
        </div>
        <div className=" font-small text-primary p-3 d-flex flex-column justify-content-start">
          <div
            className="d-flex bg-primary-dark-darker card-body py-4 px-0 w-100  align-items-center mb-1"
            style={{ borderRadius: '10px' }}
          >
            <div className="d-flex col-5 px-0">
              {this.renderAirplaneIcon(operatingAirlines, 0, 'col-3')}
              {this.renderMainColumn(
                operatingAirlines.length === 1
                  ? operatingAirlines[0].name
                    ? operatingAirlines[0].name[name]
                      ? operatingAirlines[0].name[name]
                      : '---'
                    : '---'
                  : this.props.intl.formatMessage({
                      id: 'booking.multiairline',
                    }),
                this.returnDirection(
                  pnrFlights?.flights?.itineraries,
                  pnrFlights,
                  flightsLength,
                  name,
                ),
                false,
                'w-100',
              )}
            </div>
            <div className="d-flex col-3 px-0">
              {this.renderMainColumn(
                `${passengerCount} ${this.props.intl.formatMessage({
                  id: 'booking.passenger',
                })}`,
                `${
                  pnrFlights?.flights?.adultCount > 0
                    ? `${
                        pnrFlights?.flights?.adultCount
                      } ${this.props.intl.formatMessage({
                        id: 'booking.Adult',
                      })}`
                    : ''
                } 
              ${
                pnrFlights?.flights?.childCount > 0
                  ? `${
                      pnrFlights?.flights?.childCount
                    } ${this.props.intl.formatMessage({
                      id: 'booking.child',
                    })}`
                  : ''
              } 
              ${
                pnrFlights?.flights?.infantCount > 0
                  ? `${
                      pnrFlights?.flights?.infantCount
                    } ${this.props.intl.formatMessage({
                      id: 'booking.infant',
                    })}`
                  : ''
              }`,
                false,
                'w-100',
                pnrFlights._id,
                'passengerDetail',
              )}
            </div>
            <div className="d-flex col-2 px-0">
              {this.renderMainColumn(
                this.props.intl.formatMessage({
                  id: 'booking.ticketprice',
                }),
                `${Math.round(
                  pnrFlights.totalPrice / 10,
                )} ${this.props.intl.formatMessage({
                  id: 'booking.toman',
                })}`,

                true,
                `w-100`,
                pnrFlights._id,
                'totalprice',
              )}
            </div>
            <div className="d-flex col-2 px-0">
              {this.renderMainColumn(
                this.props.intl.formatMessage({
                  id: 'booking.payableamount',
                }),
                `${Math.round(
                  pnrFlights.totalPriceToPayment / 10,
                )} ${this.props.intl.formatMessage({
                  id: 'booking.toman',
                })}`,
                true,
                `w-100`,
              )}
            </div>
          </div>

          <div className="position-relative">
            {this.state.showPriceDetailId === pnrFlights._id && (
              <div
                className="text-center col-9 position-absolute "
                style={{
                  zIndex: 50,
                  top: 10,
                  // bottom: '-40%',
                  right: direction === 'rtl' ? '10%' : 'auto',
                  left: direction === 'ltr' ? '10%' : 'auto',
                  fontSize: '1rem',
                }}
              >
                <BookingPriceDetails
                  priceList={priceList}
                  parsedQueryStr={parsedQueryStr}
                  item={pnrFlights}
                  backgroundColor="#151a44"
                />
              </div>
            )}
          </div>
          <div className="position-relative">
            {this.state.showPassengerDetailId === pnrFlights._id && (
              <div
                className="text-center col-112 position-absolute "
                style={{
                  zIndex: 50,
                  // bottom: "10%",
                  right: direction === 'rtl' ? '00%' : 'auto',
                  left: direction === 'ltr' ? '00%' : 'auto',
                  fontSize: '1rem',
                }}
              >
                <div className="card shadow-lg bg-primary-dark-darker">
                  <PassengerTable
                    passengerLst={pnrFlights.passengers}
                    direction={direction}
                    className="text-dark"
                  />
                </div>
              </div>
            )}
          </div>
          <BookingFlightDetails
            bookingId={pnrFlights._id}
            details={pnrFlights?.flights}
            flightType={pnrFlights?.flights?.flightType.toLowerCase()}
            isModal={false}
            showPrice={false}
            flight={pnrFlights}
            isBooking={true}
            tickets={pnrFlights?.tickets ? pnrFlights.tickets : []}
          />
          <div
            className="d-flex flex-row  w-100 py-3 d-flex justify-content-start"
            style={{
              backgroundColor: '#47518c',
              borderBottomLeftRadius: '10px',
              borderBottomRightRadius: '10px',
            }}
          >
            <div className="d-sm-flex flex-wrap flex-md-nowrap w-100 justify-content-end px-3 ">
              {this.renderPayLink(pnrFlights)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderPayLink = (item) => {
    let ticketTimeLimit = momentjs(
      new Date(item?.flights?.ticketTimeLimit + 'Z'),
    );
    let todayDate = momentjs(new Date()).format('YYYY-MM-DD HH:mm');

    let isExpired = momentjs(ticketTimeLimit).isBefore(todayDate);

    return (
      <span
        className={`font-xsmall font-md-smaller  text-underline ${
          isExpired ? 'cursor-disable' : 'cursor-pointer'
        }`}
        onClick={() => (isExpired ? null : this.createFlightInvoiceData(item))}
      >
        <FormattedMessage id="booking.paynow" />
      </span>
    );
  };

  createFlightInvoiceData = (item) => {
    let selectedAirport = JSON.parse(sessionStorage.getItem('selectedAirport'));

    // create querry string and redirect to flight invoice
    parsedQueryStr['ad'] = item?.flights.adultCount;
    parsedQueryStr['ch'] = item?.flights.childCount;
    item?.flights.itineraries.map((fly, index) => {
      let miladi = fly.flights[index].departureDateTime;

      let flightDate = {
        hejri: moment(miladi, 'YYYY-MM-DD').format('iYYYY-iMM-iDD').split('-'),

        shamsi: momentjs(miladi, 'YYYY-MM-DD')
          .format('jYYYY-jMM-jDD')
          .split('-'),
        isToday:
          new Date(miladi).toLocaleDateString() ===
          new Date().toLocaleDateString(),
        date: miladi.split('T')[0],
        miladi: miladi.split('T')[0].split('-'),
      };
      selectedAirport[index].date = flightDate;
      parsedQueryStr['in'] = item?.flights.infantCount;
      parsedQueryStr[`d${index + 1}`] =
        fly.flights[index].departureDateTime.split('T')[0];

      parsedQueryStr[`dl${index + 1}`] = true;
      parsedQueryStr['ft'] = item?.flights.flightType;
      parsedQueryStr[`fr${index + 1}`] =
        fly.flights[index].departureAirport.code;

      parsedQueryStr[`ol${index + 1}`] = false;
      parsedQueryStr[`to${index + 1}`] = fly.flights[index].arrivalAirport.code;

      parsedQueryStr['token'] = item._id;
    });
    sessionStorage.removeItem('selectFlight');
    sessionStorage.setItem('selectFlight', JSON.stringify(item?.flights));
    sessionStorage.setItem('selectedAirport', JSON.stringify(selectedAirport));

    this.props.navigate(
      `${flightBookingRoutes.flightInvoice}?${new URLSearchParams(
        parsedQueryStr,
      ).toString()}`,
    );
  };

  render() {
    const {
        showPnrPanel,
        pnrFlights,
        showLoading,
        flights,
        openToast,
        message,
      } = this.state,
      {
        language: { direction },
        intl,
      } = this.props;

    return (
      <>
        <div className="MobileBookingFlights mt-4 pt-0 pb-2 col h-100 min-vh-100 ">
          {this.renderTabs()}
          {this.filterPanels()}
          <Toast
            isOpen={openToast}
            onClose={() => this.setState({ openToast: false })}
            state={'danger'}
            position="bottom"
            message={intl.formatMessage({
              id: message,
            })}
            direction={direction}
          />
          <Modal
            modalSize="modal-xl"
            title={this.props.intl.formatMessage({
              id: 'booking.ticketinfo',
            })}
            id="pnrModal"
            isOpen={this.state.showPnrModal}
            onClose={() => this.setState({ showPnrModal: false })}
          >
            {this.renderPnrModal()}
          </Modal>
          {/* {!showPnrPanel && !showDetail ? (
            <div className="w-100 d-flex p-0  font-xsmall text-third justify-content-between align-items-center mb-4 height-tab">
              <DarkSearchInput
                name="phrase"
                value={phrase}
                className={
                  "col h-100 p-0 d-flex flex-row justify-content-center"
                }
                label="ticket.search"
                intl={intl}
                onChange={(event) =>
                  this.handleSearch("phrase", event.target.value)
                }
                language={language}
                inputClassName="px-2"
              />
              <div className="col h-100 p-0 d-flex flex-row justify-content-center">
                <DarkDateDropdown
                  name="orderDateDropdown"
                  svgIcon={
                    <DateIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
                  }
                  className="w-100 d-flex flex-row justify-content-center text-dark"
                  label="booking.orderdate"
                  boxColor="bg-white border"
                  show={isShowTransactionOrderDropDown}
                  onclick={() => handleChangedropDown("first")}
                  direction={language?.direction}
                  placement="center"
                >
                  <div className="p-3 mx-2">
                    <div className="pb-3">
                      <DatePicker
                        themeMode="light"
                        name="startOrderDate"
                        value={startDate}
                        placeholder={intl.formatMessage({
                          id: "booking.startorderdate",
                        })}
                        className="pt-4"
                        onChange={(date) => {
                          this.setState((state) => {
                            state.data.startDate = date
                              ? date.split(",")[0]
                              : null;
                            return "";
                          });
                        }}
                        inputClassName={"font-smaller"}
                        heightSize={"indropDown px-lg-0 px-3"}
                      />
                    </div>
                    <div>
                      <DatePicker
                        themeMode="light"
                        name="endOrderDate"
                        value={endDate}
                        placeholder={intl.formatMessage({
                          id: "booking.endorderdate",
                        })}
                        className="pt-4"
                        onChange={(date) => {
                          this.setState((state) => {
                            state.data.endDate = date
                              ? date.split(",")[0]
                              : null;
                            return "";
                          });
                        }}
                        inputClassName={"font-smaller"}
                        heightSize={"indropDown px-lg-0 px-3"}
                      />
                    </div>

                    <Button
                      label={intl.formatMessage({
                        id: "profile.search",
                      })}
                      className="py-2 px-3 default-border-radius-small mt-4 font-small btn-secondary"
                      disabled={this.dateDisable(startDate, endDate)}
                      onClick={() => {
                        $(`#orderDateDropdown`).toggleClass("show");
                        this.fetchFlightInfo(selectedTab, 1);
                        handleChangedropDown("first");
                      }}
                    />
                  </div>
                </DarkDateDropdown>
              </div>
              <div className="col h-100 p-0 d-flex flex-row justify-content-center">
                <DarkDateDropdown
                  name="travelDateDropdown"
                  svgIcon={
                    <DateIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
                  }
                  className="w-100 d-flex flex-row justify-content-center text-dark"
                  label="booking.traveldate"
                  boxColor="bg-white border"
                  show={isShowTransactionTravelDropDown}
                  onclick={() => handleChangedropDown("second")}
                  direction={language?.direction}
                >
                  <div className="p-3 mx-2">
                    <div className="pb-3">
                      <DatePicker
                        name="startTravelDate"
                        themeMode="light"
                        value={startTravelDate}
                        placeholder={intl.formatMessage({
                          id: "booking.startorderdate",
                        })}
                        className="pt-4"
                        onChange={(date) => {
                          this.setState((state) => {
                            state.data.startTravelDate = date
                              ? date.split(",")[0]
                              : null;
                            return "";
                          });
                        }}
                        inputClassName={"font-smaller"}
                        heightSize={"indropDown px-lg-0 px-3"}
                      />
                    </div>
                    <div>
                      <DatePicker
                        themeMode="light"
                        name="endTravelDate"
                        value={endTravelDate}
                        placeholder={intl.formatMessage({
                          id: "booking.endorderdate",
                        })}
                        className="pt-4"
                        onChange={(date) => {
                          this.setState((state) => {
                            state.data.endTravelDate = date
                              ? date.split(",")[0]
                              : null;
                            return "";
                          });
                        }}
                        inputClassName={"font-smaller"}
                        heightSize={"indropDown px-lg-0 px-3"}
                      />
                    </div>
                    <Button
                      label={intl.formatMessage({
                        id: "profile.search",
                      })}
                      className="py-2 px-3 default-border-radius-small mt-4 font-small btn-secondary"
                      disabled={this.dateDisable(
                        startTravelDate,
                        endTravelDate
                      )}
                      onClick={() => {
                        $(`#travelDateDropdown`).toggleClass("show");
                        this.fetchFlightInfo(selectedTab, 1);
                        handleChangedropDown("second");
                      }}
                    />
                  </div>
                </DarkDateDropdown>
              </div>
              <ResetFilter
                parentClassName={"col-sm-1 col-2 h-100"}
                className={"col-10"}
                handleReset={this.handleResetFilter}
              />
            </div>
          ) : showDetail ? (
            <div className="w-100 d-flex p-0 pb-2 font-xsmall text-third justify-content-around align-items-center">
              <div className="d-flex p-0 col-4">
                <DarkSearchInput
                  name="pnr"
                  icon=""
                  isMobile={true}
                  value={pnr}
                  className="w-100 font-xsmall mobile-input-search"
                  label="booking.referencenumber"
                  intl={intl}
                  onChange={(event) =>
                    this.handleSearch("pnr", event.target.value)
                  }
                  language={language}
                />
              </div>
              <div className="d-flex p-0 col-4">
                <DarkSearchInput
                  name="lastName"
                  icon=""
                  isMobile={true}
                  value={lastName}
                  className="w-100 font-xsmall mobile-input-search"
                  label="booking.leadlastname"
                  intl={intl}
                  onChange={(event) =>
                    this.handleSearch("lastName", event.target.value)
                  }
                  language={language}
                />
              </div>

              {!showLoading ? (
                <div
                  className="d-flex col-3 px-0  py-2 justify-content-center cursor-pointer bg-primary-dark-lighter text-greenish-blue"
                  onClick={() => {
                    this.fetchPnr();
                  }}
                >
                  <FormattedMessage id="booking.showflight" />
                </div>
              ) : (
                <div className="d-flex col-3 p-0 justify-content-center align-items-cenetr booking bg-primary-dark-lighter py-1">
                  <div
                    className={`spinner-border text-light  float-${(direction =
                      "rtl" ? "right" : "left")}`}
                    role="status"
                  ></div>
                </div>
              )}
            </div>
          ) : null} */}

          {/* {totalCount > 0 && (
                  <div className="col-3 d-flex flex-column justify-content-start align-items-end">
                    <div className="">
                      <span className="px-1">{totalCount}</span>
                      <FormattedMessage id="booking.index" />
                    </div>
                    <div className=" font-small">
                      <span className="px-3">
                        {totalCount === 0 ? 0 : "---"}
                      </span>
                   
                    </div>
                  </div>
                )} */}
          <Conditional checkRender={showLoading}>
            <Spinner />
          </Conditional>
          <Conditional checkRender={!showLoading}>
            <>
              <Conditional checkRender={flights.length === 0}>
                <h3 className="text-center flex-fill px-3 pb-3 pt-3">
                  <FormattedMessage id="profile.notfound" />
                </h3>
              </Conditional>
              <Conditional checkRender={flights.length !== 0}>
                <>
                  {showPnrPanel && this.renderMainFlight(pnrFlights, 0)}
                  {!showPnrPanel && this.renderflightList()}
                </>
              </Conditional>
            </>
          </Conditional>
        </div>
        {this.renderPerviousPassengerslink()}
        {this.renderOnlineSupportModal()}
        {this.state.CustomerModalData?.onBehalfProfile?.id &&
          this.showCustomerModal()}
        {this.renderAssignCustomerModal()}
      </>
    );
  }
  //#endregion
}

function mapStateToProps(state, props) {
  return {
    language: state.language,
    userInfo: state?.user?.userInfo,
  };
}
export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(MobileBookingFlights),
);
